import React, { useEffect } from "react";
import { Box, Button, Grid, rgbToHex, Typography } from "@mzc-pdc/ui";
import { alpha } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ImageFilesSelect, ImageFolderMiddleOn, ImageUpload } from "@mzc-cloudplex/icons";
import ConvertRGBAtoHex from "@utils/convert-rgba-to-hex";
import { useDropzone } from "react-dropzone";
import theme from "@styles/theme";

const UploadProvider = (props) => {
    const { t } = useTranslation();
    const { open, getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: (acceptedFiles) => {
            props.onChangeFiles(acceptedFiles);
        },
        noClick: props.disabledClick,
        disabled: props.disabled,
    });

    return (
        <>
            {isDragActive && <div style={{ minHeight: "139px", gridArea: "1/1/2/2", margin: "1px" }}></div>}
            <Grid
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: isDragActive ? "end" : "center",
                    width: "100%",
                    height: isDragActive ? undefined : "141px",
                    minHeight: "141px",
                    cursor: "pointer",
                    backgroundColor: ConvertRGBAtoHex(`rgba(201, 212, 244, ${isDragActive ? 0.72 : 0.1})`), //opacity를 별도 조작시 하위 태그들도 영향을 받아 backgroundColor에서 알파값 처리
                    border: "1px dashed #7085d0",
                    zIndex: "1000",
                    gridArea: isDragActive ? "1/1/3/2" : "1/1/2/2",
                    borderRadius: `4px`,
                }}
                {...getRootProps({ className: "dropzone" })}
            >
                <input {...getInputProps()} />
                {!isDragActive ? (
                    <>
                        <Grid container flexDirection={"column"} justifyContent={"center"} gap={theme.spacing(2)}>
                            <Grid item sx={{ display: "flex", justifyContent: "center" }}>
                                <Typography variant={"body1_500"} color={theme.palette.greySecondary.main}>
                                    {t(
                                        `common::msg::Drag and drop your file here, or upload a file from your PC or cloud.`,
                                        `Drag and drop your file here, or upload a file from your PC or cloud.`,
                                    )}
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    gap: theme.spacing(1),
                                }}
                            >
                                <Button
                                    variant={"contained"}
                                    color={"primary"}
                                    rounded={true}
                                    onClick={open}
                                    size={"small"}
                                >
                                    {t(`common::label::Upload from My PC`, `Upload from My PC`)}
                                </Button>
                                {props.children}
                            </Grid>
                        </Grid>
                    </>
                ) : (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: `column`,
                            alignItems: "center",
                            justifyContent: "center",
                            width: "370px",
                            marginBottom: `24px`,
                            padding: `17px 0 20px`,
                            borderRadius: `5px`,
                            backgroundColor: alpha(theme.palette.secondary[800], 0.95),
                        }}
                    >
                        <ImageUpload width={78} height={62} />
                        <Typography color={theme.palette.common.white}>
                            {t(`common::label::drop your files to upload`, `drop your files to upload`)}
                        </Typography>
                    </Box>
                )}
            </Grid>
        </>
    );
};

export default UploadProvider;
